// Mutable state shared between modules. Everything else is module-local.
export const state = {
  isNight: false,
  jetSki: null,
  cullD2: undefined,
  mode: 'intro',
  camHead: undefined,
  camDist: 15,
  panelOpen: false,
  lang: 'es',
  openIdx: undefined,
  nearStop: undefined,
  // the GPS route to the next stop ({ pts, len }), shared by the guide arrow and the minimap
  route: null,
  // the two-bone arm IK from the character loader, used every frame by the paddlers
  armIK: null,
  rally: null,
  updateRally: null,
};
